import { useLandingContent } from "@/features/admin/content/landingContent";

/**
 * Negocios que ya están creciendo con TecoPOS. Lista editable desde el admin
 * (logo + nombre). Si un negocio tiene logo, se muestra el logo junto al nombre.
 */
export function SocialProof() {
  const { growingBusinesses } = useLandingContent();
  if (!growingBusinesses.length) return null;
  const loop = [...growingBusinesses, ...growingBusinesses];

  return (
    <section className="py-14 border-y border-black/5 bg-neutral-50/60 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 lg:px-6">
        <p className="text-center text-[11px] font-semibold uppercase tracking-[0.2em] text-muted-foreground mb-8">
          Negocios que ya están creciendo con TecoPOS
        </p>
        <div className="relative">
          <div className="flex w-max items-center gap-10 lg:gap-14 animate-marquee">
            {loop.map((b, i) => (
              <span
                key={b.id + i}
                className="flex items-center gap-3 whitespace-nowrap text-lg lg:text-xl font-bold tracking-tight text-neutral-400"
              >
                {b.logo && (
                  <img
                    src={b.logo}
                    alt={b.name}
                    className="h-9 w-9 lg:h-10 lg:w-10 rounded-lg object-cover grayscale opacity-80"
                  />
                )}
                {b.name}
              </span>
            ))}
          </div>
          <div className="pointer-events-none absolute inset-y-0 left-0 w-20 bg-gradient-to-r from-neutral-50 to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-20 bg-gradient-to-l from-neutral-50 to-transparent" />
        </div>
      </div>
    </section>
  );
}
